/*
 * Author: Harper Yan
 * File Created: Wednesday, 25-04-09 09:58 am
 * Last Modified: Tuesday, 25-07-22 09:53 am, by Dw
 */

import { generatePaths } from '@/src/utils/url';

// Paths that should redirect to home page when user is authenticated
const NEED_REDIRECT_PATH_WHEN_LOGIN = ['/login', '/signup'];

// Public paths that are accessible without authentication
const PUBLIC_PATHS = [
  '/', // Home page
  '/login', // Login page
  '/signup', // Signup page
  '/theme',
  '/theme/next',
  '/card_mlum/apply', // Card application page
  '/welcomerewards1', // Welcome rewards page
  '/forget-password', // Password recovery page
  '/open-api-error', // Open API error page
  '/account/security/error-codes', // Error codes page
  '/dvault/referral-visa', // Temp Referral page for visa
  '/download', // Download page
  '/universal_decard_GDSKDJJHH',
];

// Generate paths with language prefixes for all public paths
export const PublicPathWithLocale = generatePaths(PUBLIC_PATHS);

// Generate paths with language prefixes for login redirect paths
export const NeedRedirectPathWhenLogin = generatePaths(
  NEED_REDIRECT_PATH_WHEN_LOGIN,
);

// Base path for the application (e.g. /dcscc)
const basePath = process.env.NEXT_PUBLIC_PREFIX_PATH;

// Generate paths with base path prefix for all public paths
export const FullPublicPath = generatePaths([''].concat(PUBLIC_PATHS))
  .map((item) => `${basePath}${item}`)
  .concat(PublicPathWithLocale);

// Generate paths with base path prefix for login redirect paths
export const FullRedirectWhenLoginPaths = NeedRedirectPathWhenLogin.map(
  (item) => `${basePath}${item}`,
).concat(NeedRedirectPathWhenLogin);
